<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden && item.children">
      <router-link
        v-if="
          hasOneShowingChildren(item.children) &&
          !item.children[0].children &&
          !item.alwaysShow
        "
        :to="item.path + '/' + showingChild(item.children).path"
        :key="showingChild(item.children).name"
      >
        <el-menu-item
          :index="item.path + '/' + showingChild(item.children).path"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <svg-icon
            v-if="
              showingChild(item.children).meta &&
              showingChild(item.children).meta.icon
            "
            :icon-class="showingChild(item.children).meta.icon"
          ></svg-icon>
          <span>{{ showingChild(item.children).meta.title }}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name || item.path" :key="item.name">
        <template slot="title">
          <svg-icon
            v-if="item.meta && item.meta.icon"
            :icon-class="item.meta.icon"
          ></svg-icon>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :routes="[child]"
            :key="child.path"
          ></sidebar-item>

          <router-link
            v-else
            :to="item.path + '/' + child.path"
            :key="child.name"
          >
            <el-menu-item :index="item.path + '/' + child.path">
              <svg-icon
                v-if="child.meta && child.meta.icon"
                :icon-class="child.meta.icon"
              ></svg-icon>
              <span v-if="child.meta && child.meta.title" slot="title">{{
                child.meta.title
              }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hasOneShowingChildren(children) {
      if (children.length > 0) {
        if (children[0].name === "home") {
          return true;
        }
      }
    },
    showingChild(children) {
      let obj = {};
      if (children[0].name === "home") {
        obj = children[0];
      } else {
        children.forEach((opt) => {
          if (!opt.hidden) {
            obj = opt;
          }
        });
      }
      return obj;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue